import React from "react";

const AiRisk = () => {
  return (
    <div
      style={{
        lineHeight: "1.4",
        fontSize: "18px",
        maxWidth: "1400px",
        margin: "0 auto",
        padding: "20px",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          marginBottom: "30px",
        }}
        className="title-cool"
      >
        Artificial Intelligence Risk Disclaimer
      </h1>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        AI INTERPRETATION RISK
      </h2>
      <p style={{ marginBottom: "15px" }}>
        Numbers.ag utilizes Artificial Intelligence (AI) to analyze and summarize
        market data. While our models are trained on official CFTC and USDA
        sources, AI-generated insights can occasionally contain inaccuracies or
        "hallucinations". All AI-driven analysis should be verified against the
        raw data visuals provided on the platform before executing any trade.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        ALGORITHMIC LIMITATIONS
      </h2>
      <p style={{ marginBottom: "15px" }}>
        AI patterns detected in historical COT or WASDE data do not guarantee
        future market movement. These insights are based on simulated analysis
        and do not represent the results of actual trading in a live account. No
        representation is being made that any producer or feeder is likely to
        achieve results similar to those discussed in AI conversations.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        DECISION-SUPPORT ONLY
      </h2>
      <p style={{ marginBottom: "15px" }}>
        Numbers.ag AI acts as a decision-support tool, not an automated trading
        system. The user retains full discretion and responsibility for all
        marketing and hedging decisions. Our AI does not account for an
        individual user's specific financial situation, risk tolerance, or local
        basis conditions.
      </p>

      <p style={{ marginTop: "30px", marginBottom: "15px" }}>
        Numbers.ag is a registered Commodity Trading Advisor (CTA) with the CFTC
        and a Member of the National Futures Association (NFA).
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        CFTC RULE 4.41
      </h2>
      <p style={{ marginBottom: "15px" }}>
        Hypothetical or simulated performance results have certain inherent
        limitations. Unlike an actual performance record, simulated results do
        not represent actual trading. Also, since the trades have not been
        executed, the results may have under-or-over compensated for the impact,
        if any, of certain market factors, such as lack of liquidity. No
        representation is being made that any account will or is likely to
        achieve profit or losses similar to those shown.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        PAST PERFORMANCE
      </h2>
      <p style={{ marginBottom: "15px" }}>
        Past performance is not necessarily indicative of future results. The
        information provided by Numbers.ag is for informational purposes and
        should be used as one of many tools in your marketing or hedging plan.
      </p>
    </div>
  );
};

export default AiRisk;
